import { render, staticRenderFns } from "./appointments.vue?vue&type=template&id=17b1f0ba&scoped=true"
import script from "./appointments.vue?vue&type=script&lang=ts"
export * from "./appointments.vue?vue&type=script&lang=ts"
import style0 from "./appointments.vue?vue&type=style&index=0&id=17b1f0ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b1f0ba",
  null
  
)

export default component.exports